import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import filesize from 'filesize';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import AppContext from '../../../context';
import s from './Attachment.scss';
import fileStyles from '../../../components/file-icons.css'; // eslint-disable-line css-modules/no-unused-class

import messages from './messages';
import intlPropTypes from '../../../constants/intlPropTypes';
var Attachment = (_dec = withStyles(s), _dec2 = withStyles(fileStyles), _dec3 = connect(function (state) {
  return {
    lesson: state.lessonDetails.lesson
  };
}), injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Attachment, _React$Component);
  var _super = _createSuper(Attachment);
  function Attachment() {
    _classCallCheck(this, Attachment);
    return _super.apply(this, arguments);
  }
  _createClass(Attachment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        lesson = _this$props.lesson,
        withVideo = _this$props.withVideo,
        item = _this$props.item,
        actionBtn = _this$props.actionBtn;
      return /*#__PURE__*/_jsx("div", {
        className: classNames(s.item, withVideo ? s.withVideo : undefined)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: classNames(s.icon, fileStyles.file, fileStyles[item.type])
      }), /*#__PURE__*/_jsx("div", {
        className: classNames(s.info, withVideo ? s.withVideo : undefined)
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        className: classNames(s.fileName, withVideo ? s.withVideo : undefined)
      }, void 0, item.name), /*#__PURE__*/_jsx("div", {
        className: s.details
      }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "body1",
        className: s.attrTitle
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.type)), ' ', _.toUpper(item.type)), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "body1",
        className: s.attrTitle
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.size)), ' ', filesize(item.size)), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "body1",
        className: s.attrTitle
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.uploaded)), ' ', moment(item.uploadedDate).format('DD/MM/YYYY HH:mm')))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.btn, withVideo ? s.withVideo : undefined)
      }, void 0, !actionBtn && /*#__PURE__*/_jsx(Button, {
        variant: "outlined",
        color: "primary",
        size: "large",
        component: "a",
        href: "".concat(this.context.apiUrl, "/api/lessons/").concat(lesson._id, "/attachments/").concat(item._id),
        target: "_blank",
        fullWidth: true
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.download)), actionBtn));
    }
  }]);
  return Attachment;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  actionBtn: null
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { Attachment as default };